import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaArrowLeft, FaStar } from "react-icons/fa";
import { API_BASE } from "../config/api";
import "./AddReviewPage.css";

const initialForm = {
  name: "",
  email: "",
  rating: 5,
  feedback: "",
};

function AddReviewPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (field) => (event) => {
    setForm((currentForm) => ({
      ...currentForm,
      [field]: event.target.value,
    }));
    setError("");
    setMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    setMessage("");

    try {
      const response = await axios.post(`${API_BASE}/reviews/general`, form);
      setMessage(response.data?.message || "Your review has been submitted for approval.");
      setForm(initialForm);
    } catch (submitError) {
      setError(
        submitError.response?.data?.message ||
          "Could not submit your review. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="add-review-page">
      <section className="add-review-card">
        <button
          type="button"
          className="add-review-back-button"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
          Back
        </button>

        <div className="add-review-heading">
          <span>Customer Review</span>
          <h1>Add Review</h1>
          <p>Your review will appear on the website after admin approval.</p>
        </div>

        {message ? <div className="add-review-success">{message}</div> : null}
        {error ? <div className="add-review-error">{error}</div> : null}

        <form className="add-review-form" onSubmit={handleSubmit}>
          <label>
            <span>Name</span>
            <input type="text" value={form.name} onChange={handleChange("name")} required />
          </label>

          <label>
            <span>Email</span>
            <input type="email" value={form.email} onChange={handleChange("email")} required />
          </label>

          <label>
            <span>Rating</span>
            <select value={form.rating} onChange={handleChange("rating")} required>
              {[5, 4, 3, 2, 1].map((rating) => (
                <option key={rating} value={rating}>{rating} Star{rating > 1 ? "s" : ""}</option>
              ))}
            </select>
          </label>

          <label className="add-review-form__wide">
            <span>Review message</span>
            <textarea
              value={form.feedback}
              onChange={handleChange("feedback")}
              rows={6}
              maxLength={500}
              required
            />
          </label>

          <button type="submit" disabled={submitting}>
            <FaStar />
            {submitting ? "Submitting..." : "Submit Review"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default AddReviewPage;
